import { NavLink } from 'react-router-dom';
import { useConfig } from '../../config';
import { useTranslation } from '../../i18n/i18n';
import { Res, useCms } from '../../state/api';
import { UiContainer } from '../../state/ui';
import { CmsComponent } from '../cms/CmsComponent';
import { Loader } from '../Loader/Loader';
import { Overlay } from '../Overlay/Overlay';
import { CategoryTree } from './CategoryTree/CategoryTree';
import './Sidebar.css';

export const Sidebar = (): JSX.Element => {
	const ui = UiContainer.useContainer();
	const isMenuOpen = ui.isMenuOpen;
	const t = useTranslation().navigation;
	const urls = useTranslation().routes;
	const { store } = useConfig();
	const { data: sidebarFooter } = useCms(Res.cmsComponent, { slug: 'sidebar-footer' });

	return (
		<>
			{isMenuOpen && <Overlay onClick={ui.toggleMenu} toggle={ui.toggleMenu} />}
			<aside id="sidebar" className={isMenuOpen ? 'open' : ''}>
				<div className="sidebar-menu">
					<CategoryTree />
				</div>
				<div className="sidebar-menu category-level-0 extra">
					<p className="extra-heading">{t.moreHeading}</p>
					<NavLink className="navigation-item" to={urls.campaigns}>
						{t.campaigns}
					</NavLink>
					{store !== 'kgdk' && (
						<NavLink className="navigation-item" to={urls.homeOffice}>
							{t.homeOffice}
						</NavLink>
					)}
					{store !== 'kgde' && store !== 'kgat' && (
						<NavLink className="navigation-item" to={urls.topSellers}>
							{t.topSellers}
						</NavLink>
					)}
					<NavLink className="navigation-item" to={urls.brands}>
						{t.brands}
					</NavLink>
					<NavLink className="navigation-item" to={urls.productsA}>
						{t.productsAo}
					</NavLink>
				</div>
				<div className="sidebar-menu cms-content">
					{sidebarFooter ? <CmsComponent structure={sidebarFooter} /> : <Loader />}
				</div>
			</aside>
		</>
	);
};
